export const iconFontAwesomeHumanitarianRoadCircleExclamation = (
	<i className="fa-solid fa-road-circle-exclamation"></i>
);
